export default __webpack_public_path__ + "static/media/golang-webapp-components.b63cdb64.png";